import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { TagsMethods } from '../../tagsManagerGrid/types';
import { TagData } from '../../types/tag-data';
import { DeepPartial } from 'typeorm';

export class TagPanelBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'GzTags';

  public async addTag(payload: DeepPartial<TagData>): Promise<{ success: boolean; errorMessage?: string }> {
    let response;
    try {
      response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: this.endpoint,
        method: TagsMethods.CREATE_RECORDS,
        payload: { records: [payload] },
      });
    } catch (e) {
      if (e.err?.exceptionType === 'Exceptions\\GzTagsLimitReachedException') {
        return {
          success: false,
          errorMessage: this.dependencies.translateFn(
            'You have reached the maximum number of tags allowed. Delete some older tags before adding new ones.'
          ),
        };
      }
    }

    if (!response || !response.success) {
      return { success: false };
    }

    return response;
  }

  public async updateTag(payload: DeepPartial<TagData>): Promise<{ success: boolean }> {
    let response;
    try {
      response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: this.endpoint,
        method: TagsMethods.UPDATE_RECORDS,
        payload: { records: [payload] },
      });
    } catch (e) {
      console.error(e);
    }

    if (!response || !response.success) {
      return { success: false };
    }

    return response;
  }

  public async getTagById(tagId: string, isClone = false): Promise<TagData> {
    let response;
    try {
      response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: this.endpoint,
        method: isClone ? TagsMethods.GET_RECORD_FOR_CLONE : TagsMethods.GET_RECORD,
        payload: { tagId: tagId },
      });
    } catch (e) {
      console.error(e);
      throw e;
    }

    if (!response || !response.success || !response.data) {
      throw new Error('No edited tag data');
    }

    return response.data;
  }

  public async getDataForView() {
    return {};
  }
}
